import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  PurchaseOrderCreateRequestDTO,
  PurchaseOrderUpdateRequestDTO,
  PurchaseOrderDeleteRequestDTO,
  PurchaseOrderReadByIdRequestDTO,
  PurchaseOrderReadByTenantIdRequestDTO,
  PurchaseOrderDTO,
  PurchaseOrderList,
  PurchaseOrderReadbyAgentIdRequestDTO,
  PurchaseOrderSearchByPurchaseOrderNoRequestDTO,
  PurchaseOrderUpdateStatusRequestDTO
} from './purchase-order.interface';

import {
  PurchaseOrder_Create,
  PurchaseOrder_Update,
  PurchaseOrder_Delete,
  PurchaseOrder_ReadById,
  PurchaseOrder_ReadByTenantId,
  PurchaseOtherCharges_Create,
  PurchaseOtherCharges_Update,
  PurchaseOtherCharges_Delete,
  PurchaseOtherCharges_ReadByPurchaseOrderId,
  PurchaseOtherCharges_ReadById,
  PurchaseOrder_ReadByAgentId,
  PurchaseOrder_SearchByPurchaseOrderNo,
  PurchaseOrder_UpdateStatus
} from 'src/app/GlobalVariables';
import { PurchaseOtherChargesCreateRequestDTO, PurchaseOtherChargesDeleteRequestDTO, PurchaseOtherChargesDTO, PurchaseOtherChargesList, PurchaseOtherChargesReadByIdRequestDTO, PurchaseOtherChargesReadByPurchaseOrderIdRequestDTO, PurchaseOtherChargesUpdateRequestDTO } from './purchaseorderothercharges.interface';

@Injectable({
  providedIn: 'root'
})
export class PurchaseOrderService {

  http = inject(HttpClient);

  PurchaseOrder_Create(data: PurchaseOrderCreateRequestDTO): Observable<PurchaseOrderDTO> {
    return this.http.post<PurchaseOrderDTO>(PurchaseOrder_Create, data);
  }

  PurchaseOrder_Update(data: PurchaseOrderUpdateRequestDTO): Observable<PurchaseOrderDTO> {
    return this.http.post<PurchaseOrderDTO>(PurchaseOrder_Update, data);
  }
  PurchaseOrder_UpdateStatus(data: PurchaseOrderUpdateStatusRequestDTO): Observable<PurchaseOrderDTO> {
    return this.http.post<PurchaseOrderDTO>(PurchaseOrder_UpdateStatus, data);
  }

  PurchaseOrder_Delete(data: PurchaseOrderDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseOrder_Delete, data);
  }

  PurchaseOrder_ReadById(data: PurchaseOrderReadByIdRequestDTO): Observable<PurchaseOrderDTO> {
    return this.http.post<PurchaseOrderDTO>(PurchaseOrder_ReadById, data);
  }

  PurchaseOrder_ReadByTenantId(data: PurchaseOrderReadByTenantIdRequestDTO): Observable<PurchaseOrderList> {
    return this.http.post<PurchaseOrderList>(PurchaseOrder_ReadByTenantId, data);
  }

  PurchaseOrder_ReadByAgentId(data: PurchaseOrderReadbyAgentIdRequestDTO): Observable<PurchaseOrderList> {
    return this.http.post<PurchaseOrderList>(PurchaseOrder_ReadByAgentId, data);
  }

  PurchaseOrder_SearchByPurchaseOrderNo(data: PurchaseOrderSearchByPurchaseOrderNoRequestDTO): Observable<PurchaseOrderList> {
    return this.http.post<PurchaseOrderList>(PurchaseOrder_SearchByPurchaseOrderNo, data);
  }



  //     purchaseOrderOthercharges

  PurchaseOtherCharges_Create(data: PurchaseOtherChargesCreateRequestDTO): Observable<PurchaseOtherChargesDTO> {
    return this.http.post<PurchaseOtherChargesDTO>(PurchaseOtherCharges_Create, data);
  }


  PurchaseOtherCharges_Update(data: PurchaseOtherChargesUpdateRequestDTO): Observable<PurchaseOtherChargesDTO> {
    return this.http.post<PurchaseOtherChargesDTO>(PurchaseOtherCharges_Update, data);
  }


  PurchaseOtherCharges_Delete(data: PurchaseOtherChargesDeleteRequestDTO): Observable<void> {
    return this.http.post<void>(PurchaseOtherCharges_Delete, data);
  }


  PurchaseOtherCharges_ReadByPurchaseOrderId(data: PurchaseOtherChargesReadByPurchaseOrderIdRequestDTO): Observable<PurchaseOtherChargesList> {
    return this.http.post<PurchaseOtherChargesList>(PurchaseOtherCharges_ReadByPurchaseOrderId, data);
  }


  PurchaseOtherCharges_ReadById(data: PurchaseOtherChargesReadByIdRequestDTO): Observable<PurchaseOtherChargesDTO> {
    return this.http.post<PurchaseOtherChargesDTO>(PurchaseOtherCharges_ReadById, data);
  }
}
